import React from 'react';
import Select from 'react-select';

import './FilterSelector.scss';
import { WpIcon } from 'Wpds/components/icon';

const selectStyles = label => ({
  container: styles => ({
    ...styles,
    width: `${label.length > 10 ? label.length * 10 + 18 : label.length * 10 + 48}px`,
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    textTransform: 'uppercase',
    zIndex: 2,
  }),
  menu: styles => ({
    ...styles,
    width: '170px',
  }),
  control: styles => ({ ...styles, border: 'none', boxShadow: 'none', cursor: 'pointer' }),
  option: styles => ({ ...styles, fontSize: '12px' }),
  singleValue: styles => ({
    ...styles,
    fontSize: '12px',
    color: '#0238BB',
    outline: 'none',
    border: 'none',
    bottom: '-5px',
  }),
  dropdownIndicator: styles => ({ ...styles, fontSize: '12px', color: '#0238BB' }),
});

type Props = {
  label: string;
  value: {
    label: string;
    value: string;
  };
  options: Array<{
    label: string;
    value: string;
  }>;
  onChange: Function;
};

function FilterSelector({ label, value, options, onChange }: Props) {
  return (
    <div className="filter-selector d-flex align-items-center mr-2">
      <span className="filter-selector-label mr-1">{label}</span>
      <Select
        isSearchable={false}
        value={value}
        options={options}
        components={{
          DropdownIndicator: () => <WpIcon name="chevron-down" className="filter-selector-indicator p-2" />,
          IndicatorSeparator: null,
        }}
        styles={selectStyles(value.label)}
        onChange={onChange}
      />
    </div>
  );
}

export default FilterSelector;
